import { User } from "./types";
import Cookies from "js-cookie";

type CookiesType = { [key: string]: string };
type Base64Decode = (input: string) => string;

const decodeInNodeJs = (data: string): string =>
  Buffer.from(data, "base64").toString("utf-8");

const REA_USER_INFO_COOKIE = "reauinf";
const REASTOK_COOKIE = "reastok";
const REAUTOK_COOKIE = "reautok";
const REAUID_COOKIE = "reauid";
const PCAUID_COOKIE = "pcauid";
const COUNTRY_COOKIE = "Country";

const getUserInfo = (
  reauinf: string,
  decode: Base64Decode,
): { lockeId: string; consumerId: string; isNewUser: boolean } | null => {
  try {
    const { lid, cid, isNewUser } = JSON.parse(decode(reauinf)) as {
      lid: string;
      cid: string;
      isNewUser: boolean;
    };
    return {
      lockeId: lid,
      consumerId: cid,
      isNewUser,
    };
  } catch {
    return null;
  }
};

const createUser = (
  cookies: CookiesType,
  decode: Base64Decode,
  isServer: boolean,
): User => {
  const reauinf = cookies[REA_USER_INFO_COOKIE];
  const reautok = cookies[REAUTOK_COOKIE];
  const reastok = cookies[REASTOK_COOKIE];
  const userId = { userId: cookies[REAUID_COOKIE] };
  const country = { countryCode: cookies[COUNTRY_COOKIE] || undefined };

  if (reauinf) {
    const userInfo = getUserInfo(reauinf, decode);
    if (userInfo) {
      return {
        isSignedIn: true,
        isNewUser: userInfo.isNewUser,
        consumerId: userInfo.consumerId,
        lockeId: userInfo.lockeId,
        ...userId,
        ...country,
        ...(isServer && !reautok && !reastok && { isTokenExpired: true }),
      };
    }
  }

  return {
    isSignedIn: false,
    isNewUser: false,
    ...userId,
    ...country,
  };
};
const createUserForPCA = (cookies: CookiesType): User => {
  const userId = cookies[PCAUID_COOKIE];
  const countryCode = cookies[COUNTRY_COOKIE];
  return {
    isSignedIn: false,
    isNewUser: false,
    userId,
    countryCode,
  };
};

export const createBrowserUser = (cookies: CookiesType = Cookies.get()): User =>
  createUser(cookies, window.atob, false);

export const createBrowserUserForPCA = (
  cookies: CookiesType = Cookies.get(),
): User => createUserForPCA(cookies);

export const createServerUser = (cookies: CookiesType): User =>
  createUser(cookies, decodeInNodeJs, true);

export const createNullUser = (): User => ({
  isSignedIn: false,
  isNewUser: false,
});
